import { render, staticRenderFns } from "./EmployeeBasicView.vue?vue&type=template&id=588cd20e&"
import script from "./EmployeeBasicView.vue?vue&type=script&lang=js&"
export * from "./EmployeeBasicView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports